module.exports = __webpack_public_path__ + "static/media/logPan.720496fe.svg";